import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RoutingService, TranslationService, WindowRef, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { pairwise } from 'rxjs/operators';
import { Constants } from 'src/app/core/constants/url.constants';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-custom-update-profile',
    templateUrl: './custom-update-profile.component.html',
    styleUrls: ['./custom-update-profile.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, FormsModule, ReactiveFormsModule, NgFor, NgIf, I18nModule]
})
export class CustomUpdateProfileComponent implements OnInit {
  customerId: any;
  enableLoader: boolean;
  master: any;
  title: any;
  newform: any;
  navigationData: any;
  salutation: any;
  roles: any;
  addcontactform: UntypedFormGroup;
  modcontact: any;
  errorMessage: any;
  userid: any;
  usergroup: any;
  contacts: any;
  userContact: any;
  userGroupName: any;
  error: any;
  admin: any;
  role = 'manager';
  isDisabled = false;
  writeAccess: any;
  isCustomerEmulated: boolean;
  isSaveDisabled: boolean =false;
  constructor(private routingService: RoutingService,
              private httpUtilService: HttpUtilService,
              public toastService: ToastService,
              private cd: ChangeDetectorRef,
              private userAccountFacade: UserAccountFacade,
              private translation: TranslationService,
              private fb: UntypedFormBuilder,
              private customProductService: CustomProductsService,
              private router: Router,
              private customProfileService: CustomProfileService,
              private winRef: WindowRef,private customloginservice:CustomLoginService,
              private csAgentAuthService:CsAgentAuthService
              ) { }

  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isSaveDisabled = true;
        }else{
          this.isSaveDisabled = false;
        }
      })
    })
    this.customProductService.getHomeLinkActive(false);
    this.translation.translate('breadcrumb.updatePersonalDetails.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.updatePersonalDetails.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('home.toastErrorMessages.dataSaved').subscribe(res => {
      this.error = res;
    });
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data) {
        this.userid = data.uid;
        this.customerId = data.customerId;
        this.usergroup = this.customProfileService.getGroupCompany();
       // this.usergroup = data.orgUnit.uid;
        this.getMasterData();
        this.getContacts();
        if (this.winRef.localStorage.getItem('groupCompanyAdminFlag')) {
          this.admin = JSON.parse(this.winRef.localStorage.getItem('groupCompanyAdminFlag'));
        }
        // if (data.uid === this.addcontactform.uid){
        if (this.admin){
              this.role = 'admin';
          }
      // }
        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          if (previous !== current) {
            if (current != null) {
              this.enableLoader = true;
              if (this.router.url === '/profile/my-account/update-personal-details') {
                this.getMasterData();
                this.getContacts();
              }
            }
          }
        });
      }
      this.createForm();
    });

  }


  getContacts(): any {
    this.httpUtilService.get(Constants.getgroupuser(this.userid, this.usergroup).CONTACTS)
      .subscribe(res => {
        if (res) {
          this.enableLoader = false;
          this.contacts = res;
          this.contacts = this.contacts.users.filter((us) => {
            return us.uid === this.userid;
          });
          this.cd.detectChanges();
          this.userContact = this.contacts[0];
          if (this.userContact.mobileNumber ){
            this.userContact.mobileNumber = this.userContact.mobileNumber.replace(' ', '');
        }
          if (this.userContact.alternateNumber ){
          this.userContact.alternateNumber = this.userContact.alternateNumber.replace(' ', '');
      }

          this.createForm();
        }
      }, (error) => {
        this.errorMessage = error;
        this.enableLoader = false;
      });
  }
  createForm(): any {
    this.addcontactform = this.fb.group({
      titleCode: [this.userContact ? this.userContact.titleCode : ''],
      firstName: [this.userContact ? this.userContact.firstName : '', [Validators.required]],
      lastName: [this.userContact ? this.userContact.lastName : '', [Validators.required]],
      email: [this.userContact ? this.userContact.uid : '', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}')]],
      mobileNumber: [this.userContact ? this.userContact.mobileNumber : '', [Validators.pattern('^[+0-9]{0,15}$')]],
      alternateNumber: [this.userContact ? this.userContact.alternateNumber : '', [Validators.pattern('^[+0-9]{0,15}$')]],
      department: [this.userContact ? this.userContact.department : ''],
      jobTitle: [this.userContact ? this.userContact.jobTitle : ''],
      modeOfContact: [this.userContact ? this.userContact.modeOfContact : ''],
      uid: [this.userContact ? this.usergroup : this.usergroup],
      role: [{ value: this.role , disabled: !this.admin }],
      // name: [this.userContact ? this.userContact.orgUnit.name : this.userGroupName],
    });
  }
  getMasterData(): any {
    this.httpUtilService.get(Constants.getgroupuser(this.userid, this.usergroup).MASTERDATA)
      .subscribe(res => {
        if (res) {
          this.enableLoader = false;
          this.master = res;
          this.salutation = this.master.titles;
          this.roles = this.master.roles;
          this.modcontact = this.master.modeOfContacts;
          this.cd.detectChanges();
        }
      }, (error) => {
        this.errorMessage = error;
        this.enableLoader = false;
      });
  }
  createcontact(i: any): any {
    this.cd.detectChanges();
    this.newform = this.addcontactform.value;
    this.newform.unit = { uid: this.addcontactform.value.uid };
    delete this.newform.uid;
    const role = this.addcontactform.value.role;
    delete this.newform.role;
    this.newform.role = this.role;
    this.httpUtilService.post(Constants.getgroupuser(this.userid, this.usergroup)
      .UPDATECONTACTS + this.userid + '?fields=DEFAULT', this.newform)
      .subscribe(res => {
        this.toastService.show(this.error);
        this.navigateToDetails();
        this.enableLoader = false;
        this.cd.detectChanges();
      }, (error) => {
        this.errorMessage = error;
        this.enableLoader = false;
      });
  }
  navigateToDetails(): any {
    this.routingService.go({
      cxRoute: 'home',
    });
  }
  submitForm(): void {
    if (this. addcontactform.valid) {
      // this.loginUser();
      this.isDisabled = true;
    } else {
      this. addcontactform.markAllAsTouched();
    }
  }

}
